import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar, IconButton, Typography, Box, Badge, Avatar, Button, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Divider, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import CollectionsIcon from '@mui/icons-material/Collections';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import { getSession, getSessionJSON, setSession } from '../../utils/SessionUtils';
// import { findAllContext } from '../../api/yourApi';

function Header({ handleLogout }) {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [userData, setUserData] = useState({});
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState('');

  const menuItems = [
    { text: 'Inventory', icon: <Inventory2Icon />, href: '/items' },
    { text: 'Banners', icon: <CollectionsIcon />, href: '/banners' },
    { text: 'Item Grouping', icon: <GroupWorkIcon />, href: '/groupings' },
    { text: 'Orders', icon: <ShoppingCartIcon />, href: '/orders' },
    { text: 'Logout', icon: <LogoutIcon />, href: '/' },
  ];
  useEffect(() => {
    const storedContexts = getSessionJSON("CONTEXTS");
    if (storedContexts) {
      setCompanies(storedContexts);
      let companyCodeInSession = getSession("COMPANY");
      let companyObj = storedContexts.find(context => context.companyCode === companyCodeInSession);
      setSelectedCompany(companyObj || '');
    }
    const loginData = getSessionJSON("login-data");
    if (loginData) {
      setUserData(loginData);
    }
  }, []);
  const handleMenuClick = (href, item) => {
    if (item.text === 'Logout') {
      handleLogout();
    } else {
      navigate(href, { replace: true });
    }
    setDrawerOpen(false);
  };

  const handleCompanyChange = (e) => {
    const companyValue = e.target.value;
    setSelectedCompany(companyValue);
    setSession("COMPANY", companyValue.companyCode);
    //refresh
    window.location.reload();
    // Optionally, trigger any logic needed when company changes
  };

  return (
    <>
      <AppBar position="static" sx={{ background: 'linear-gradient(135deg, #1a3c6e 0%, #1b4d8f 100%)', boxShadow: '0 1px 0 rgba(255,255,255,0.08), 0 2px 12px rgba(0,0,0,0.2)' }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }} onClick={() => setDrawerOpen(true)}>
            <MenuIcon />
          </IconButton>
          <Box component="img" src={'assets/imgs/avantech-logo_1.webp'} alt="logo" sx={{ height: 40, width: 'auto', mr: 2, borderRadius: 2, background: '#fff' }} />
          <Typography variant="h6" sx={{ fontWeight: 700, letterSpacing: 1, mr: 4, color: '#fff' }}>
            Avantec Store
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          {/* Company Select moved to right end */}
          
          <IconButton sx={{ mr: 2, color: '#fff' }}>
            <Badge badgeContent={3} color="error">
              <NotificationsIcon />
            </Badge>
          </IconButton>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.15)', color: '#fff', fontWeight: 700, border: '1.5px solid rgba(255,255,255,0.35)', width: 36, height: 36, fontSize: '0.95rem' }}>
              {userData?.userName ? userData.userName.charAt(0).toUpperCase() : <AccountCircle sx={{ fontSize: 22 }} />}
            </Avatar>
            <Typography variant="body1" sx={{ fontWeight: 500, color: '#fff',mr:2 }}>
              {userData ? <span>Welcome, <b>{userData.userName}</b></span> : "Welcome, Guest"}
            </Typography>
            <FormControl size="small" sx={{ minWidth: 160, mr: 2, background: '#fff', borderRadius: 2 }}>
            <Select
              labelId="company-select-label"
              id="company-select"
              value={selectedCompany}
              onChange={handleCompanyChange}
            >
              {companies.map((company) => (
                <MenuItem key={company.companyCode} value={company}>
                  {company.ContextDescription ? company.ContextDescription:""}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          </Box>
          
        </Toolbar>
      </AppBar>
      <Drawer anchor="left" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <Box sx={{ width: 250, bgcolor: '#f5f6fa', height: '100%' }} role="presentation" onClick={() => setDrawerOpen(false)}>
          <Typography variant="h6" sx={{ fontWeight: 700, letterSpacing: 1, p: 2, color: '#1a3c6e' }}>
            Menu
          </Typography>
          <Divider />
          <List>
            {menuItems.map((item) => (
              <ListItem key={item.text} disablePadding>
                <ListItemButton onClick={() => handleMenuClick(item.href, item)}>
                  <ListItemIcon sx={{ color: '#1a3c6e' }}>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} primaryTypographyProps={{ fontWeight: 600, fontSize: 16, color: '#1a3c6e' }} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  );
}

export default Header;
